/**
 * Generates initials from user's name information
 * @param firstName - The user's first name
 * @param lastName - The user's last name
 * @param email - The user's email
 * @returns The initials string
 */
export function getInitials(
  firstName: string | null,
  lastName: string | null,
  email: string | null
): string {
  if (firstName && lastName) {
    return firstName.charAt(0) + lastName.charAt(0);
  }

  if (firstName) {
    return firstName.charAt(0);
  }

  if (lastName) {
    return lastName.charAt(0);
  }

  if (email) {
    return email.charAt(0);
  }

  return '?';
}
